import { post } from '@/api/request'
import config from '@/config'
import { RequestOption } from '../request'

// export const checkUserChatNeedSubscription = (params: any) => {
//     return post(`api/solve-x-ai/membership_v2/member-action-limit`, params)
// }

export const checkWebUserSparksLimit = (params: any, option: Omit<RequestOption, 'data'> = {}) => {
    return post(`api/solve-x-ai/webuser/sparks/limit-check`, params, {
        header: {
            'X-Internal-Secret': config.internalSecret
        },
        abortController: option.abortController
    })
}
